var _rect, _text, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 50,
    viewBox: "0 0 180 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 50,
    rx: 10,
    fill: "#B22222"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 32,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fontWeight: "bold",
    fill: "#ffffff"
  }, "\r\n    Quick ", /*#__PURE__*/React.createElement("tspan", {
    fill: "#FF6347"
  }, "Flick"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "155,15 170,25 155,35",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ed99796a57ac029af93dfb8d08e6080e.svg";
export { ForwardRef as ReactComponent };